import React from "react";

import "./sideDrawer.css";
import userImg from "../../../images/user.png";
import en from "../../../images/english.png";
import es from "../../../images/spanish.png";

const sideDrawer = (props) => {
  let drawerClasses = "side-drawer";
  if (props.show) {
    drawerClasses = "side-drawer open";
  }

  if (props.today_badge === "" || props.today_badge === undefined)
    props.today_badge = 0;
  if (props.tomorrow_badge === "" || props.tomorrow_badge === undefined)
    props.tomorrow_badge = 0;
  if (props.messages_badge === "" || props.messages_badge === undefined)
    props.messages_badge = 0;
  if (props.yesterday_badge === "" || props.yesterday_badge === undefined)
    props.yesterday_badge = 0;

  let fondo_home = { background: "#f9f9f9" };
  let fondo_today = { background: "#f9f9f9" };
  let fondo_yesterday = { background: "#f9f9f9" };
  let fondo_tomorrow = { background: "#f9f9f9" };
  let fondo_messages = { background: "#f9f9f9" };
  let fondo_settlements = { background: "#f9f9f9" };
  let fondo_profile = { background: "#f9f9f9" }
  let fondo_assistance = { background: "#f9f9f9" };


  switch (props.label) {
    case "home":
      fondo_home = { background: "#e1dede" };
      break;
    case "today":
      fondo_today = { background: "#e1dede" };
      break;
    case "yesterday":
      fondo_yesterday = { background: "#e1dede" };
      break;
    case "tomorrow":
      fondo_tomorrow = { background: "#e1dede" };
      break;
    case "messages":
      fondo_messages = { background: "#e1dede" };
      break;
    case "settlements":
      fondo_settlements = { background: "#e1dede" };
      break;
    case "profile":
      fondo_profile = { background: "#e1dede" };
      break;
    case "assistance":
      fondo_assistance = { background: "#e1dede" };
      break;
    default:
  }

  var language = localStorage.getItem("language");

  return (
    <nav className={drawerClasses}>
      <ul>
        <li>
          <div className='app' style={{ background: "#ffffff" }}>
            <div className='user_div1'>
              <div className='user_div2' data-column='profile' onClick={props.click}>
                <img
                  src={userImg}
                  alt=''
                  style={{ width: "45px", height: "45px" }}
                />
              </div>

              <div className='user_div3' data-column='profile' onClick={props.click}>
                <div className='user_div4'>{localStorage.getItem("name")}</div>
                <div className='user_div5'>{localStorage.getItem("email")}</div>
              </div>

              <div className='user_div6'>
                <i
                  className='material-icons left'
                  style={{ fontSize: "22px" }}
                  data-column='settings'
                  onClick={props.click}
                >
                  settings
                </i>
              </div>
            </div>
          </div>
        </li>

        <li>
          <div
            className='divider'
            style={{ background: "#eeeeee", paddingTop: "2px" }}
          ></div>
          <div
            className='app'
            style={fondo_home}
            data-column='home'
            onClick={props.click}
          >
            <div
              className='app opcion_div1'
              style={{ fondo_home, color: "black", marginLeft: "10px" }}
            >
              <div className='opcion_div3' style={{ width: "40px" }}>
                <i
                  className='material-icons left'
                  style={{
                    fontSize: "30px",
                    position: "relative",
                    top: "-2px",
                  }}
                >
                  home
                </i>
              </div>
              <div className='opcion_div2'>
                <span className='item__titulo'>
                  {language === "en" ? "Home" : "Inicio"}
                </span>
              </div>
              <div className='opcion_div3' style={{ width: "100px" }}></div>
            </div>
            <div
              className='divider'
              style={{ background: "#eeeeee", paddingBottom: "2px" }}
            ></div>
          </div>
        </li>

        <li>
          <div
            className='app'
            style={fondo_today}
            data-column='today'
            onClick={props.click}
          >
            <div
              className='app opcion_div1'
              style={{ fondo_today, color: "black", marginLeft: "10px" }}
            >
              <div className='opcion_div3' style={{ width: "40px" }}>
                <i className='material-icons left' style={{ fontSize: "30px" }}>
                  assignment
                </i>
              </div>
              <div className='opcion_div2'>
                <span className='item__titulo'>
                  {language === "en" ? "Today's Trips" : "Viajes de Hoy"}
                </span>
              </div>
              <div className='opcion_div3' style={{ width: "90px" }}>
                {props.today_badge > 0 ? (
                  <div
                    className='opcion_badge'
                    style={{ width: "36px", height: "24px" }}
                  >
                    {props.today_badge}
                  </div>
                ) : null}
              </div>
            </div>
            <div
              className='divider'
              style={{ background: "#eeeeee", paddingBottom: "2px" }}
            ></div>
          </div>
        </li>

        <li>
          <div
            className='app'
            style={fondo_yesterday}
            data-column='yesterday'
            onClick={props.click}
          >
            <div
              className='app opcion_div1'
              style={{ fondo_yesterday, color: "black", marginLeft: "10px" }}
            >
              <div className='opcion_div3' style={{ width: "40px" }}>
                <i className='material-icons left' style={{ fontSize: "30px" }}>
                  event_busy
                </i>
              </div>
              <div className='opcion_div2'>
                <span className='item__titulo'>
                  {language === "en" ? "Yesterday's Trips" : "Trips de Ayer"}
                </span>
              </div>
              <div className='opcion_div3' style={{ width: "90px" }}>
                {props.yesterday_badge > 0 ? (
                  <div
                    className='opcion_badge'
                    style={{ width: "36px", height: "24px" }}
                  >
                    {props.yesterday_badge}
                  </div>
                ) : null}
              </div>
            </div>
            <div
              className='divider'
              style={{ background: "#eeeeee", paddingBottom: "2px" }}
            ></div>
          </div>
        </li>

        <li>
          <div
            className='app'
            style={fondo_tomorrow}
            data-column='tomorrow'
            onClick={props.click}
          >
            <div
              className='app opcion_div1'
              style={{ fondo_tomorrow, color: "black", marginLeft: "10px" }}
            >
              <div className='opcion_div3' style={{ width: "40px" }}>
                <i className='material-icons left' style={{ fontSize: "30px" }}>
                  event_note
                </i>
              </div>
              <div className='opcion_div2'>
                <span className='item__titulo'>
                  {language === "en" ? "Tomorrow's Trips" : "Viajes de Mañana"}
                </span>
              </div>
              <div className='opcion_div3' style={{ width: "100px" }}>
                {props.tomorrow_badge > 0 ? (
                  <div
                    className='opcion_badge'
                    style={{ width: "36px", height: "24px" }}
                  >
                    {props.tomorrow_badge}
                  </div>
                ) : null}
              </div>
            </div>
            <div
              className='divider'
              style={{ background: "#eeeeee", paddingBottom: "2px" }}
            ></div>
          </div>
        </li>

        <li>
          <div
            className='app'
            style={fondo_settlements}
            data-column='settlements'
            onClick={props.click}
          >
            <div
              className='app opcion_div1'
              style={{ fondo_settlements, color: "black", marginLeft: "10px" }}
            >
              <div className='opcion_div3' style={{ width: "40px" }}>
                <i className='material-icons left' style={{ fontSize: "30px" }}>
                  list_alt
                </i>
              </div>
              <div className='opcion_div2'>
                <span className='item__titulo'>
                  {language === "en" ? "Trip History" : "Historial de Viajes"}
                </span>
              </div>
            </div>
            <div
              className='divider'
              style={{ background: "#eeeeee", paddingBottom: "2px" }}
            ></div>
          </div>
        </li>
        {/* <li>
          <div
            className='app'
            style={fondo_messages}
            data-column='messages'
            onClick={props.click}
          >
            <div
              className='app opcion_div1'
              style={{ fondo_messages, color: "black", marginLeft: "10px" }}
            >
              <div className='opcion_div3' style={{ width: "40px" }}>
                <i
                  className='material-icons left'
                  style={{ fontSize: "30px", position: "relative", top: "1px" }}
                >
                  chat
                </i>
              </div>
              <div className='opcion_div2'>
                <span className='item__titulo'>
                  {language === "en" ? "Messenger" : "Mensajería"}
                </span>
              </div>
              <div className='opcion_div3' style={{ width: "100px" }}>
                {props.messages_badge > 0 ? (
                  <div
                    className='opcion_badge'
                    style={{ width: "36px", height: "24px" }}
                  >
                    {props.messages_badge}
                  </div>
                ) : null}
              </div>
            </div>
            <div
              className='divider'
              style={{ background: "#eeeeee", paddingBottom: "2px" }}
            ></div>
          </div>
        </li>
        <li>
          <div
            className='app'
            style={fondo_profile}
            data-column='profile'
            onClick={props.click}
          >
            <div
              className='app opcion_div1'
              style={{ fondo_profile, color: "black", marginLeft: "10px" }}
            >
              <div className='opcion_div3' style={{ width: "40px" }}>
                <i
                  className='material-icons left'
                  style={{ fontSize: "30px", position: "relative", top: "1px" }}
                >
                  badge
                </i>
              </div>
              <div className='opcion_div2'>
                <span className='item__titulo'>
                  {language === "en" ? "ID" : "ID"}
                </span>
              </div>
              <div className='opcion_div3' style={{ width: "100px" }}></div>
            </div>
            <div
              className='divider'
              style={{ background: "#eeeeee", paddingBottom: "2px" }}
            ></div>
          </div>
        </li>
        <li>
          <div
            className='app'
            style={fondo_assistance}
            data-column='assistance'
            onClick={props.click}
          >
            <div
              className='app opcion_div1'
              style={{ fondo_profile, color: "black", marginLeft: "10px" }}
            >
              <div className='opcion_div3' style={{ width: "40px" }}>
                <i
                  className='material-icons left'
                  style={{ fontSize: "30px", position: "relative", top: "1px" }}
                >
                  departure_board
                </i>
              </div>
              <div className='opcion_div2'>
                <span className='item__titulo'>
                  {language === "en" ? "Assistance" : "Asistencia"}
                </span>
              </div>
              <div className='opcion_div3' style={{ width: "100px" }}></div>
            </div>
            <div
              className='divider'
              style={{ background: "#eeeeee", paddingBottom: "2px" }}
            ></div>
          </div>
        </li> */}
        <li>
          <div
            className='divider'
            style={{ background: "#ffffff", paddingTop: "60px" }}
          ></div>
          <div
            className='divider'
            style={{ background: "#eeeeee", paddingBottom: "2px" }}
          ></div>
          <div
            className='app'
            style={{ background: "#f9f9f9" }}
            data-column={language}
            onClick={props.click}
          >
            <div
              className='app'
              style={{
                background: "#f9f9f9",
                color: "black",
                marginLeft: "10px",
                paddingLeft: "5px",
              }}
            >
              {language === "en" ? (
                <img
                  src={es}
                  alt=''
                  style={{
                    width: "25px",
                    height: "25px",
                    position: "relative",
                    top: "6px",
                  }}
                />
              ) : (
                <img
                  src={en}
                  alt=''
                  style={{
                    width: "25px",
                    height: "25px",
                    position: "relative",
                    top: "6px",
                  }}
                />
              )}
              <span className='item__titulo' style={{ paddingLeft: "15px" }}>
                {language === "en" ? "Cambiar a Español" : "Change to English"}
              </span>
            </div>
            <div
              className='divider'
              style={{ background: "#eeeeee", paddingBottom: "2px" }}
            ></div>
          </div>
        </li>

        <li>
          <div
            className='divider'
            style={{ background: "#ffffff", paddingTop: "2px" }}
          ></div>
          <div
            className='app'
            style={{ background: "#f9f9f9" }}
            data-column='logout'
            onClick={props.click}
          >
            <div
              className='app'
              style={{
                background: "#f9f9f9",
                color: "black",
                marginLeft: "10px",
              }}
            >
              <i className='material-icons left' style={{ fontSize: "30px" }}>
                settings_power
              </i>
              <span className='item__titulo'>
                {language === "en" ? "Logout" : "Salir"}
              </span>
            </div>
            <div
              className='divider'
              style={{ background: "#eeeeee", paddingBottom: "2px" }}
            ></div>
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default sideDrawer;
